/** Converts pt to half-points for docx font sizes */
export const convertPtToHalfPt = (pt: number): number => pt * 2;

/** Converts pt to twips for docx spacing */
export const convertPtToTwip = (pt: number): number => pt * 20;

/** Converts pt to pixels at Word's default 96 DPI */
export const convertPtToPx = (pt: number): number => Math.round(pt * (96 / 72));

/**
 * Converts a line-height multiplier to Word's line spacing unit (240ths of a line).
 * In docx, 240 equals single-spaced. For example, 1.5 → 360 (1.5× spacing).
 */
export const convertLineHeight = (multiplier: number): number =>
  Math.round(240 * multiplier);

/** Strips the leading `#` from a hex color string for docx compatibility */
export const convertHexToDocx = (hex: string): string => hex.replace('#', '');
